// sequences of the different IAT options
// keys are the sections of the IAT
//! critical to end every instance of a IAT study with 'test'; otherwise the config generation will not work
//! this is also used for the correct behavior when reseting archived results
export const instructionMapping = {
  introduction: ['welcome', 'consent'],
  pdf: ['viewer'],
  IAT: [
    'overview',
    'intro',
    'IAT-finger-placement',
    'countdown',
    'IAT-test',
    'section-end',
  ],
  priming: [
    'overview',
    'intro',
    'IAT-finger-placement',
    'countdown',
    'IAT-test',
    'section-end',
  ],
  conjoint: [
    'overview',
    'intro',
    'practice-intro',
    'countdown',
    'practice-test',
    'IAT-intro',
    'countdown',
    'IAT-test',
    'section-end',
  ],
  persona: [
    'overview',
    'intro',
    'baseline-intro',
    'baseline-test',
    'how-to',
    'instruction-speed',
    'practice-intro',
    'IAT-question',
    'IAT-finger-placement',
    'countdown',
    'practice-test',
    'IAT-intro',
    'IAT-question',
    'IAT-finger-placement',
    'countdown',
    'IAT-test',
    'section-end',
  ],
  brand: [
    'overview',
    'intro',
    'baseline-intro',
    'baseline-test',
    'how-to',
    'instruction-speed',
    'practice-intro',
    'practice-image',
    'IAT-question',
    'IAT-finger-placement',
    'countdown',
    'practice-test',
    'IAT-intro',
    'IAT-image',
    'IAT-question',
    'IAT-finger-placement',
    'countdown',
    'IAT-test',
    'section-end',
  ],
  OT: [
    'overview',
    'intro',
    'baseline-intro',
    'baseline-test',
    'how-to',
    'instruction-speed',
    'practice-intro',
    'practice-test',
    'IAT-intro',
    'IAT-test',
    'section-end',
  ],
  // changed modular for industry needsphere - removed some instructions and baseline
  modular: [
    'overview',
    'intro',
    'practice-intro',
    'IAT-finger-placement',
    'countdown',
    'practice-test',
    'IAT-intro',
    'IAT-question',
    'IAT-finger-placement',
    'countdown',
    'IAT-test',
    'section-end',
  ],
  agreement: [
    'overview',
    'intro',
    'baseline-intro',
    'baseline-test',
    'how-to',
    'instruction-speed',
    'practice-intro',
    'practice-test',
    'IAT-intro',
    'IAT-test',
    'section-end',
  ],
  questionnaire: ['questionnaire'],
  final: ['final'],
};

// define study sections
export const studySections = [
  'persona',
  'brand',
  'OT',
  'agreement',
  'modular',
  'IAT',
  'priming',
  'conjoint',
];
